import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Sidebar from './Sidebar';

function Main({ children }) {
    const [activeItem, setActiveItem] = useState('');

  return (
    <Grid container className='container-fluid' sx={{ my: 3 }}>
      <Grid item xs={12} md={3}>
        <Sidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </Grid>

      <Grid item xs={12} md={9}>
        {children}
      </Grid>
    </Grid>
  );
}

export default Main;
